import { type PaymentProvider } from '@wix/cashier-common/dist/src/enums/payments/PaymentProvider';
import { type PaymentMethod } from '@wix/cashier-common/dist/src/enums/payments/PaymentMethod';
import { spbAnyErrorDuringGpayFlow as spbAnyErrorDuringGpayFlowOriginal } from '@wix/bi-logger-payments-data/v2';
import { type spbAnyErrorDuringGpayFlowParams as spbAnyErrorDuringGpayFlowParamsOriginal } from '@wix/bi-logger-payments-data/v2/types';

export type spbAnyErrorDuringGpayFlowParams = spbAnyErrorDuringGpayFlowParamsOriginal & {
  paymentmethod: PaymentMethod.GooglePay;
  paymentProvider: PaymentProvider;
};

export const spbAnyErrorDuringGpayFlow: (
  p: spbAnyErrorDuringGpayFlowParams,
) => ReturnType<typeof spbAnyErrorDuringGpayFlowOriginal> = spbAnyErrorDuringGpayFlowOriginal;
